import { MutableRefObject, useEffect, useRef, useState } from 'react';

type UseBoundingRectApi = [MutableRefObject<HTMLDivElement | null>, DOMRect | null];

// Via: https://legacy.reactjs.org/docs/hooks-faq.html#how-can-i-measure-a-dom-node
// This is the official way to measure the boundingRect of a DOM element in a reactive
// way (i.e. with useState so you get notified about changes)
// Added: resize handler as well
export const useBoundingRect = (): UseBoundingRectApi => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [rect, setRect] = useState<DOMRect | null>(null);

  const updateRect = () => {
    setRect(ref.current?.getBoundingClientRect() || null);
  };

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    updateRect();
    window.addEventListener('resize', updateRect);
    return () => window.removeEventListener('resize', updateRect);
  }, []);

  return [ref, rect];
};
